
<template>
    <div class="flex float-left vertical-center">
        <vs-chip class="line-0" v-bind:color="statusColor">
            {{statusText}}
        </vs-chip>
    </div>
</template>

<script>
    import Vue from "vue";

    export default Vue.extend({
        name: "StatusDeviceRequestAgGridComponent",
        data() {
            return {
                statusColor: '',
                statusText: ''
            }
        },
        mounted() {
            if (this.params.value !== '' && this.params.value !== null && this.params.value !== undefined) {
                if (this.params.value === 'pending') {
                    this.statusColor = 'warning'
                    this.statusText = 'Pending'
                } else if (this.params.value === 'progress') {
                    this.statusColor = 'primary'
                    this.statusText = 'Progress'
                } else if (this.params.value === 'finish') {
                    this.statusColor = 'success'
                    this.statusText = 'Finish'
                } else if (this.params.value === 'cancel'){
                    this.statusColor = 'danger'
                    this.statusText = 'Cancel'
                }
            }
            else {
                this.statusText = 'Pending'
                this.statusColor = 'warning'
            }
        }
    })
</script>

<style scoped>
    .vertical-center {
        margin: 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }

    .line-0 {
        line-height: 0;
    }
</style>